import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'panel'];

  toggle(event) {
    const button = event.currentTarget;
    this.setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
  }

  expandAll() {
    this.toggleTargets.forEach((button) => this.setExpanded(button, true));
  }

  collapseAll() {
    this.toggleTargets.forEach((button) => this.setExpanded(button, false));
  }

  setExpanded(button, expanded) {
    const panel = this.panelTargets.find((element) => element.id === button.getAttribute('aria-controls'));
    if (!panel) return;

    button.setAttribute('aria-expanded', String(expanded));
    panel.classList.toggle('hidden', !expanded);
  }
}
